import classNames from "classnames";
import { Immutable } from "immer";
import React, { useId } from "react";
import ReactTooltip from "react-tooltip";
import { t } from "ttag";

import { IEditorialBadge } from "../../models/catalogue";

import styles from "./index.module.scss";

export const EditorialBadgeChip = (
    props: Immutable<{
        badge: IEditorialBadge | null | undefined;
        className?: string;
    }>,
): React.JSX.Element | null => {
    // useId() returns ids containing ':' which are valid HTML but break
    // react-tooltip v4's internal `#${id}` CSS selector — sanitize to keep
    // the tooltip attachment working.
    const tipId = `editorial-badge-${useId().replace(/:/g, "")}`;
    const badge = props.badge;
    if (!badge) {
        return null;
    }
    const hasTooltip = badge.description.trim().length > 0;
    const className = classNames(
        styles.chip,
        "editorial-badge",
        props.className,
    );
    return (
        <span className={className}>
            <span className={styles.label}>{badge.display_label}</span>
            {hasTooltip && (
                <>
                    <button
                        type="button"
                        className={styles.infoButton}
                        data-tip={true}
                        data-for={tipId}
                        aria-describedby={tipId}
                        aria-label={t`More information about ${badge.display_label}`}
                    >
                        <svg
                            className={styles.infoIcon}
                            xmlns="http://www.w3.org/2000/svg"
                            viewBox="0 0 24 24"
                            aria-hidden="true"
                            focusable="false"
                        >
                            <circle
                                cx="12"
                                cy="12"
                                r="11"
                                fill="none"
                                stroke="currentColor"
                                strokeWidth="1.5"
                            />
                            <path
                                d="M12 10v7M12 7.5h.01"
                                fill="none"
                                stroke="currentColor"
                                strokeWidth="1.75"
                                strokeLinecap="round"
                            />
                        </svg>
                    </button>
                    <ReactTooltip
                        id={tipId}
                        uuid={tipId}
                        className="editorial-badge__tooltip"
                        event="mouseover focus"
                        eventOff="mouseout blur"
                        delayHide={100}
                        delayShow={150}
                        effect="solid"
                        role="tooltip"
                        place="bottom"
                    >
                        {badge.description}
                    </ReactTooltip>
                </>
            )}
        </span>
    );
};
